import { useEffect } from "react";
import styled from "styled-components";
import { BASIC_DARK_GRAY, BASIC_WHITE } from "../../../constants/colors";
import { Button } from "../../atoms/Button";
import { FavoriteIcon } from "../../atoms/FavoriteIcon";
import { StoreMap } from "./StoreMap";

type Props = {
  isShow: boolean;
  name: string;
  address: string;
  phoneNumber: string;
  service: string;
  location: { lat: number; lng: number };
  isFavorite: boolean;
  onFavorite: (favorite: boolean) => void;
  onClose: () => void;
};

export const StoreDetailPopup: React.FC<Props> = ({
  isShow,
  name,
  address,
  phoneNumber,
  service,
  location,
  isFavorite,
  onFavorite,
  onClose,
}) => {
  useEffect(() => {
    if (isShow) {
      document.body.classList.add("overflow-hidden");
    } else {
      document.body.classList.remove("overflow-hidden");
    }

    return () => {
      document.body.classList.remove("overflow-hidden");
    };
  }, [isShow]);

  return (
    <StoreDetailPopupContainer $isShow={isShow}>
      <StoreMap location={location} />

      <StoreInfoContainer>
        <StoreInfoHeader>
          <StoreName>{name}</StoreName>

          <FavoriteIcon
            type="star"
            favorite={isFavorite}
            onClick={onFavorite}
          />
        </StoreInfoHeader>

        <StoreDetailWrapper>
          {address && (
            <StoreDetailRow>
              <StoreDetailTitle>住所</StoreDetailTitle>
              <StoreDetailText>{address}</StoreDetailText>
            </StoreDetailRow>
          )}
          {phoneNumber && (
            <StoreDetailRow>
              <StoreDetailTitle>電話番号</StoreDetailTitle>
              <StoreDetailText>{phoneNumber}</StoreDetailText>
            </StoreDetailRow>
          )}
          {service && (
            <StoreDetailRow>
              <StoreDetailTitle>サービス</StoreDetailTitle>
              <StoreDetailText>{service}</StoreDetailText>
            </StoreDetailRow>
          )}
        </StoreDetailWrapper>
      </StoreInfoContainer>

      <ButtonWrapper>
        <Button
          btnStyle="secondary"
          onClick={onClose}
          text="戻る"
          rounded="md"
        />
      </ButtonWrapper>
    </StoreDetailPopupContainer>
  );
};

const StoreDetailPopupContainer = styled.div<{ $isShow: boolean }>`
  position: fixed;
  top: 50px;
  left: 0;
  width: 100%;
  height: calc(100% - 50px);
  background-color: ${BASIC_WHITE};
  opacity: ${({ $isShow }) => ($isShow ? 1 : 0)};
  transform: ${({ $isShow }) =>
    $isShow ? "translate(0, 0)" : "translate(0, 100%)"};
  transition: all 0.5s cubic-bezier(0.13, 0.79, 0.36, 0.97);
  overflow: scroll;
  z-index: 9999;
`;

const StoreInfoContainer = styled.div`
  max-width: 768px;
  margin: auto;
  display: flex;
  flex-direction: column;
  padding-top: 34px;
`;

const StoreInfoHeader = styled.div`
  display: flex;
  margin: 0 16px 25px;
`;

const StoreDetailWrapper = styled.div`
  margin: 0 16px 15px;
`;

const StoreName = styled.div`
  text-align: left;
  flex: 1;
  padding: 0 0 0 0;
  margin: 0 0 0 0;
  font-size: 20px;
  font-weight: 600;
  color: ${BASIC_DARK_GRAY};
`;

const StoreDetailTitle = styled.div`
  text-align: left;
  width: 90px;
  font-size: 16px;
  color: ${BASIC_DARK_GRAY};
  margin-bottom: 20px;
  font-weight: 300;
`;

const StoreDetailRow = styled.div`
  display: flex;
`;

const StoreDetailText = styled.div`
  text-align: left;
  font-size: 16px;
  color: ${BASIC_DARK_GRAY};
  margin-bottom: 20px;
  font-weight: 300;
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: 0 16px;
  margin: 0 auto;
  max-width: 375px;
  button {
    line-height: 1;
    height: auto;
    padding: 20px 0 18px;
    width: 100%;
  }
`;
